import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["style"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function TriangleArrow(props) {
  var {
      style
    } = props,
    reset = _objectWithoutPropertiesLoose(props, _excluded);
  var defaultStyle = _extends({
    cursor: 'pointer',
    height: '1em',
    width: '1em'
  }, style);
  return /*#__PURE__*/_jsx("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "var(--w-rjv-arrow-color, currentColor)",
    style: defaultStyle
  }, reset, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
    })
  }));
}